<template>
  <div style="margin: 0 auto; position: relative">
    <div style="border: 1px solid #dddddd; border-bottom: none; background-color: #f5f7fa">
      <el-radio-group v-model="decision" style="margin: 5px 0 5px 1%">
        <el-radio :label="0">同意</el-radio>
        <el-radio :label="1">
          转交
          <el-select
              v-if="decision === 1"
              v-model="transferPerson"
              placeholder="请选择"
              clearable
              filterable
              style="width: 120px">
            <el-option v-for="item in transferPersons" :key="item.value" :label="item.label" :value="item.value"/>
          </el-select>
        </el-radio>
        <el-radio :label="2">
          拒绝
          <el-select
              v-if="decision === 2"
              v-model="canUntreatedNodes"
              placeholder="请选择"
              clearable
              style="width: 120px">
            <el-option v-for="item in canUntreatedNodeList" :key="item.value" :label="item.label" :value="item.value"/>
          </el-select>
        </el-radio>
        <el-button :loading="approveLoading" style="margin-left: 50px" type="primary" @click="submit">审批</el-button>
      </el-radio-group>
    </div>
    <div style="border: 1px solid #dddddd; padding: 10px" class="vm-form">
      <vm-form v-if="decision === 0 && billType !=='28' && billType !=='31'" :data="approveInitial.applicationVarVOS"
               :node-id="approveInitial.nodeId"
               :show-yes-no-text="billType =='3'&&approveInitial.applicationVarVOS.some(item => item.varName === 'IsSpecial')"/>
      <table class="gridtable" style="width: 100%" cellspacing="0">
        <tr>
          <td style="width: 10%; text-align: right; background-color: #d1e6f5">审批意见</td>
          <td style="height: 60px">
            <el-input
                v-model="suggestion"
                style="width: 50%"
                type="textarea"
                :rows="3"
                class="tag"/>
          </td>
        </tr>
      </table>
    </div>
  </div>
</template>
<script>
  import VmForm from "@/components/VmForm.vue";

  export default {
    name: "ApprovalHeadForm",
    components: {VmForm},
    props: {
      billType: {
        type: String,
        required: true,
      },
      billId: {
        type: String,
        required: true,
      },
      sequId: {
        type: String,
        required: true,
      },
    },
    data() {
      return {
        approveLoading: false,
        transferPerson: "",
        nodeId: "",
        approveVar: "",
        transferPersons: [],
        canUntreatedNodes: "",
        canUntreatedNodeList: [],
        decision: 0,
        suggestion: "",
        approveInitial: {
          applicationVarVOS: [],
        },
      };
    },
    mounted() {
      this.getData();
    },
    methods: {
      getData() {
        this.$emit("loading-status", {loading: true});
        let params = {
          billType: this.billType,
          billId: this.billId,
          sequId: this.sequId,
        };
        this.$http.get("basic", "applications/approve", params).then((resp) => {
          this.$emit("loading-status", {loading: false});
          this.approveInitial = resp;
          console.log(this.approveInitial);
          this.nodeId = this.approveInitial.nodeId;
          for (let item in this.approveInitial.transferPersons) {
            this.transferPersons.push({value: item, label: this.approveInitial.transferPersons[item]});
          }
          for (let item in this.approveInitial.canUntreatedNodes) {
            if (this.approveInitial.canUntreatedNodes[item] === "=提交人=") {
              this.approveInitial.canUntreatedNodes[item] = "=提交人=";
            }
            this.canUntreatedNodeList.push({value: item, label: this.approveInitial.canUntreatedNodes[item]});
          }
        });
      },
      submit() {
        if (this.decision === 1) {
          if (this.transferPerson === "" || this.transferPerson === null) {
            return this.$message.error("请选择转交人");
          }
          if (this.suggestion === "" || this.suggestion === null) {
            return this.$message.error("审批意见必须填写");
          }
        }
        if (this.decision === 2) {
          if (this.canUntreatedNodes === "" || this.canUntreatedNodes === null) {
            return this.$message.error("请选择拒绝理由");
          }
          if (this.suggestion === "" || this.suggestion === null) {
            return this.$message.error("审批意见必须填写");
          }
        }
        this.approveLoading = true;
        let approveVar = "";
        let list = this.approveInitial.applicationVarVOS;
        if (list.length > 0) {
          for (let i = 0; i < list.length; i++) {
            if (i === list.length - 1) {
              approveVar += list[i].varName + "#" + list[i].varValue;
            } else {
              approveVar += list[i].varName + "#" + list[i].varValue + "|";
            }
          }
        }
        // 消息总线通知刷新待办销售订单列表
        this.$confirm("确定审批吗?", "提示", {type: "warning"})
            .then(() => {
              this.$emit("loading-status", {loading: true});
              if (this.billType === "1") {
                console.log(this.billType);
              } else if (this.billType === "3" || this.billType === "20") {
                let params = {};
                if (this.decision === 0) {
                  params = {
                    actionType: this.decision,
                    approveNote: this.suggestion,
                    untreadedFlowId: "0;submitter",
                    applicationVarVOS: this.approveInitial.applicationVarVOS,
                  };
                } else if (this.decision === 1) {
                  params = {
                    actionType: this.decision,
                    approveNote: this.suggestion,
                    untreadedFlowId: this.transferPerson,
                    applicationVarVOS: this.approveInitial.applicationVarVOS,
                  };
                } else {
                  params = {
                    actionType: this.decision,
                    approveNote: this.suggestion,
                    untreadedFlowId: this.canUntreatedNodes,
                  };
                }
                this.$emit("sucess-save", params);
              } else if (this.billType === "13" || this.billType === "23" || this.billType === "24" || this.billType === "25" || this.billType === "26" || this.billType === "27"
                  || this.billType === "15" || this.billType === "28" || this.billType === "29" || this.billType === "31" || this.billType === "32"
                  || this.billType === "33" || this.billType === "34" || this.billType === "35" || this.billType === "36") {
                let params = {};
                if (this.decision === 0) {
                  params = {
                    actionType: this.decision,
                    approveNote: this.suggestion,
                    untreadedFlowId: "0;submitter",
                    approveVar: approveVar,
                    nodeId: this.nodeId,
                    applicationVarVOS: this.approveInitial.applicationVarVOS,
                  };
                } else if (this.decision === 1) {
                  params = {
                    actionType: this.decision,
                    approveNote: this.suggestion,
                    untreadedFlowId: this.transferPerson,
                    transferTo: this.transferPerson,
                    approveVar: approveVar,
                    nodeId: this.nodeId,
                    applicationVarVOS: this.approveInitial.applicationVarVOS,
                  };
                } else {
                  params = {
                    actionType: this.decision,
                    approveNote: this.suggestion,
                    untreadedFlowId: this.canUntreatedNodes,
                  };
                }
                this.$emit("sucess-save", params);
              }
              this.$emit("loading-status", {loading: false});
              this.approveLoading = false;
            })
            .catch(() => {
              this.$emit("loading-status", {loading: false});
              this.approveLoading = false;
            });
      },
    },
  };
</script>
<style lang="scss" scoped>
.vm-form {
  table.gridtable {
    font-family: verdana, arial, sans-serif;
    font-size: 11px;
    color: #333333;
    border-width: 1px;
    border-color: #dddddd;
    border-collapse: collapse;
  }

  table.gridtable td {
    border-width: 1px;
    padding: 4px;
    border-style: solid;
    border-color: #dddddd;
  }
}
</style>
